import reducer from '../reducers';
import { compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

//For the redux dev tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js